Marquee3k.init({
  selector: 'js-marquee'
});